import React, { useState, useEffect, useRef } from "react";
import MDBox from "components/MDBox";
import Slide91 from "assets/images/TheSolutionImages/Slide9/Slide91.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function Slide9() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);
  const scrollRef = useRef();

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 1300;

      const isIpadProLandscape =
        window.innerWidth >= 1350 &&
        window.innerWidth <= 1370 &&
        window.innerHeight >= 1000 &&
        window.innerHeight <= 1050;

      setShowScrollIcon(isSmallScreen || isIpadProLandscape);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1320px" }}
        height={{ xs: "auto", md: "540px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
          color: "#FFFFFF",
          "*": {
            color: "#FFFFFF !important",
          },
        }}
      >
        {/* Left Column - Scrollable Text */}
        <MDBox flex="1" display="flex" flexDirection="column" height="100%" maxHeight="100%" pr={1}>
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            SharpWatch® Eco-System
          </h1>

          {/* Scrollable Text Block */}
          <MDBox
            ref={scrollRef}
            fontSize={{ xs: "18px", md: "24px" }}
            lineHeight={1.6}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "300px", md: "none" },
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <div style={{ marginBottom: "16px", fontSize: "24px" }}>Access anywhere, anytime</div>
            <div style={{ marginBottom: "16px" }}>
              Operators and engineers can interact securely from:
            </div>
            <ul style={{ paddingLeft: "20px", margin: 0, fontSize: "20px" }}>
              <li>Mobile phones</li>
              <li>Laptops</li>
              <li>Web-based dashboards</li>
            </ul>
          </MDBox>

          {/* Scroll Icon below the scrollable text */}
          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                fontSize: "30px",
                color: "#FFFFFF",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right Column - Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "65%" }}
          maxWidth={{ xs: "100%", md: "900px" }}
          mt={{ xs: 3, md: 0 }}
        >
          <img
            src={Slide91}
            alt="SharpWatch Eco-System Access"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Bounce Animation Style */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide9;
